
<template>
  <div>
    <card-loading-transparent v-if="loading_users" loadingText='Carregando usuários'></card-loading-transparent>
    <template v-if="!loading_users">
      <v-data-table :mobile-breakpoint="1" :headers="headers" :items="all_users" sort-by="name" class="elevation-0">
        <template v-slot:item.created_at="{item}">
          {{ $dayjs(item.created_at).format("LL") }}
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Api from '@/api';

export default {
  name: 'PainelUsersList',
  data() {
    return {
      loading_users: false,
      all_users: [],
      headers:[
        {text: 'Nome', value: 'name'},
        {text: 'Data de criação', value: 'created_at'},
        {text: 'E-mail', value: 'email'},
      ],
    }
  },
  methods: {
    getInfos(){
      this.getUsers();
    },
    getUsers() {
      this.loading_users = true 
      Api.SuperAdminControl.indexUsers().then(r=>r.data).then(d => {
        this.all_users = [...d];
      }).catch((err)=>{
        err = err.response? err.response.status : err
        this.addNotification({ type: 'error', msg: `Erro: ${err}`});
      }).finally(()=>{
        this.loading_users = false
      })
    },
    ...mapActions({
      addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      user: state=> state.User.user
    })
  },
  mounted () {
    this.getInfos();
  },
}
</script>

<style scoped>

</style>